import React from "react";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../store/contexts";
import { ErrorDialog } from "../../../../common/controls";
import { TenantStorageUsageListStore } from "../../store/TenantStorageUsageListStore";

type TenantStorageUsageListDialogsProps = {
  store: TenantStorageUsageListStore;
};

/**
 * Componente que agrupa todos los dialogs del listado de TenantStorageUsage.
 * Separado para mantener TenantStorageUsageListPage más limpio.
 */
export const TenantStorageUsageListDialogs: React.FC<TenantStorageUsageListDialogsProps> =
  observer(({ store }) => {
    const { langStore } = useRootStore();

    return (
      <>
        {/* Dialog de error genérico */}
        <ErrorDialog
          open={store.errorDialogOpened}
          title={store.errorTitle || langStore.errorTitle}
          description={store.errorDescription}
          onClose={() => store.closeErrorDialog()}
        />
      </>
    );
  });
